import { axiosRequest } from '@/util/axios-request'

// 批量发送，是否提示批量发送弹框
export const batchNotic = data =>
  axiosRequest({
    url: '/web/payroll_sub_project_staff/isShowBatchSendCombineNotice',
    method: 'POST',
    data
  })

// 保存-批量发送工资条
export const saveBatchSend = data =>
  axiosRequest({
    url: '/web/payslip/saveBatchSend',
    method: 'POST',
    data
  })

// 创建模版时获取模版详情
export const getAllColumns = data =>
  axiosRequest({
    url: '/web/payslip/getAllColumns',
    method: 'GET',
    params: data
  })

// 获取已有的模版详情
export const getSchemeInfo = data =>
  axiosRequest({
    url: '/web/payslip/getSchemeInfo',
    method: 'GET',
    params: data
  })

// 保存新建工资条模板
export const addscheme = data =>
  axiosRequest({
    url: '/web/payslip/addscheme',
    method: 'POST',
    data
  })

// 保存编辑工资条模板
export const editScheme = data =>
  axiosRequest({
    url: '/web/payslip/editScheme',
    method: 'POST',
    data
  })

// 获取模版列表
export const getSchemeList = data =>
  axiosRequest({
    url: '/web/payslip/getSchemeList',
    method: 'GET',
    params: data
  })

// 工资条模版 删除
export const deleteScheme = data =>
  axiosRequest({
    url: '/web/payslip/deleteScheme',
    method: 'POST',
    data
  })

// 获取结算类型
export const getTypeAndTaxList = () =>
  axiosRequest({
    url: '/web/payslip/getTypeAndTaxList',
    method: 'GET'
  })

// 待发送的子项目list
export const awaitsendlist = data =>
  axiosRequest({
    url: '/web/payslip/awaitsendlist',
    method: 'GET',
    params: data
  })

// 待发送的子项目list
export const getSendAllColumns = data =>
  axiosRequest({
    url: '/web/payslip/getSendAllColumns',
    method: 'GET',
    params: data
  })

// 待发送的子项目list
export const getSchemeListBySubId = data =>
  axiosRequest({
    url: '/web/payslip/getSchemeListBySubId',
    method: 'GET',
    params: data
  })

// 发送工资条
export const sendPayslip = data =>
  axiosRequest({
    url: '/web/payslip/sendPayslip',
    method: 'POST',
    data
  })

// 已经发送-工资条的pay_month list
export const getSentPayMonth = data =>
  axiosRequest({
    url: '/web/payslip/sentPayMonthList',
    method: 'GET',
    params: data
  })

// 已经发送-工资条的list
export const getSentList = data =>
  axiosRequest({
    url: '/web/payslip/sentList',
    method: 'GET',
    params: data
  })

// 待发子项目选择工资条
export const recallSent = data =>
  axiosRequest({
    url: '/web/payslip/recallSent',
    method: 'POST',
    data
  })

// 待发子项目取消定时任务
export const cancelTimedSend = data =>
  axiosRequest({
    url: '/web/payslip/cancelTimedSend',
    method: 'POST',
    data
  })

// 已经发送-工资条设置
export const sentPayslipSetting = data =>
  axiosRequest({
    url: '/web/payslip/sentPayslipSetting',
    method: 'GET',
    params: data
  })

// 已经发送-payslip info
export const sentPayslipInfo = data =>
  axiosRequest({
    url: '/web/payslip/sentPayslipInfo',
    method: 'GET',
    params: data
  })

// 已经发送-错误重发
export const afreshSendErrStaff = data =>
  axiosRequest({
    url: '/web/payslip/afreshSendErrStaff',
    method: 'GET',
    params: data
  })

// 已经发送-payslip info
export const sentPayslipStaffList = data =>
  axiosRequest({
    url: '/web/payslip/sentPayslipStaffList',
    method: 'GET',
    params: data
  })

// 发送工资条 错误重发 状态
export const getAfreshSendStatus = data =>
  axiosRequest({
    url: '/web/payslip/getAfreshSendStatus',
    method: 'GET',
    params: data
  })

// 发送工资条 获取发送状态
export const getPayslipSentState = data =>
  axiosRequest({
    url: '/web/payslip/getPayslipSentState',
    method: 'GET',
    params: data
  })

// 验证工资条姓名是否可用
export const validateSchemeName = data =>
  axiosRequest({
    url: '/web/payslip/validateSchemeName',
    method: 'POST',
    data
  })

// 工资条模版pdf
export const previewSchemePdf = data =>
  axiosRequest({
    url: '/web/payslip/previewSchemePdf',
    method: 'POST',
    data
  })

// 员工过往工资条列表查询
export const downloadPayslipList = data =>
  axiosRequest({
    url: '/web/payslip/downloadPayslipList',
    method: 'GET',
    params: data
  })

// 下载工资条 发送邮箱
export const sendPdfToEmail = data =>
  axiosRequest({
    url: '/web/payslip/sendPdfToEmail',
    method: 'POST',
    data
  })

// 下载工资条
export const downloadPdf = data =>
  axiosRequest({
    url: '/web/payslip/downloadPdf',
    method: 'POST',
    data
  })

// 全部下载工资条
export const downloadPayslipZip = data =>
  axiosRequest({
    url: '/web/payslip/downloadPayslipZip',
    method: 'get',
    params: data
  })

// 工资条安全配置枚举项
export const payslipConfigInit = data =>
  axiosRequest({
    url: '/web/payslip/payslipConfigInit',
    method: 'get',
    params: data
  })

// 获取工资条安全配置
export const getPayslipConfig = data =>
  axiosRequest({
    url: '/web/payslip/getPayslipConfig',
    method: 'get',
    params: data
  })

// 保存工资条安全配置
export const savePayslipConfig = data =>
  axiosRequest({
    url: '/web/payslip/savePayslipConfig',
    method: 'get',
    params: data
  })

// 获取工资条安全配置修改记录
export const getPayslipConfigLog = data =>
  axiosRequest({
    url: '/web/payslip/getPayslipConfigLog',
    method: 'get',
    params: data
  })
//   /app/payslip/getPayslipConfigLog
